// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__fMSJo","content":"LoadingAlert_content__3SPUr"};